import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, throwError } from "rxjs";
import { ToastService } from "../toast/toast.service";
import { EncryptDecryptService } from "../encryptor/encrypt-decrypt.service";
import { AuthService } from "../auth/auth.service";
import { getFriendlyErrorResponse } from "../errors/error-response.util";
import { SKIP_ERROR_TOAST } from "./http-context.tokens";

function showToast(toastService: ToastService, title: string, message: string) {
  toastService.addToast({
    type: "error",
    message: `
      <h2>${title}</h2>
      <p>${message}</p>
    `
  });
}

const EXPIRED_PASSWORD_CHALLENGE_STATUSES = [400, 401, 410, 422];

function isHandledAuthPrecondition(reqUrl: string, statusCode: number): boolean {
  const url = reqUrl.toLowerCase();

  if (url.includes("/adminuser/admin/change-expired-password")) {
    return EXPIRED_PASSWORD_CHALLENGE_STATUSES.includes(statusCode);
  }

  return statusCode === 428 && url.includes("/adminuser/login");
}

export const errorsInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const toastService = inject(ToastService);
  const encryptDecrypt = inject(EncryptDecryptService);
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: unknown) => {
      const statusCode = (error as HttpErrorResponse)?.status || 0;

      if (isHandledAuthPrecondition(req.url, statusCode)) {
        return throwError(() => error);
      }

      const friendlyError = getFriendlyErrorResponse(error, encryptDecrypt);

      if (friendlyError.statusCode === 401) {
        authService.logout();
        showToast(toastService, friendlyError.title, friendlyError.message);
        router.navigateByUrl("/login");
        return throwError(() => error);
      }

      if (req.context.get(SKIP_ERROR_TOAST)) {
        return throwError(() => error);
      }

      showToast(toastService, friendlyError.title, friendlyError.message);
      return throwError(() => error);
    })
  );
};
